<template>
	<div>
		<div class="page-title">Crash</div>
		<div class="crash" :class="{game: game, pause: pause, ready: ready}">
			<div class="crash__main">
				<div class="crash__game">
					<div id="crashBg" :style="{backgroundImage: `url(${imgDir}/stars_bg.png)`}">
						<img :src="imgDir + '/planet.png'" id="crashPlanet" alt="">
						<img :src="imgDir + '/comet.png'" id="crashComet" alt="">
						<img :src="imgDir + '/asteroid.png'" id="crashAsteroids" alt="">
						<img :src="imgDir + '/nebula.png'" id="crashNebula" alt="">
						<img :src="imgDir + '/blackhole.png'" id="crashBlackhole" alt="">
						<img :src="imgDir + '/nebula2.png'" id="crashNebula2" alt="">
						<img :src="imgDir + '/sunburn.png'" id="crashSunburn" alt="">
						<img :src="imgDir + '/gas-giant.png'" id="crashGasGiant" alt="">
						<img :src="imgDir + '/meteor-shower.png'" id="crashMeteorShower" alt="">
						<img :src="imgDir + '/collapse.png'" id="crashCollapse" alt="">
						<img :src="imgDir + '/quazar.png'" id="crashQuazar" alt="">
						<img :src="imgDir + '/ufo.webp'" id="crashUfo" alt="">
					</div>
					<img :src="imgDir + '/landscape.png'" id="crashLandscape" alt="">
					<img :src="imgDir + '/explosion.png'" id="crashExplosion" alt="">
					<div v-if="history?.length" class="crash__history" :class="{expand: expandHistory}">
						<div class="crash__history-items">
							<div class="crash__history-item game-step__item" v-for="historyItem in history"
								 :class="{
									danger: historyItem.final_rate === 1,
									blue: 6 > historyItem.final_rate && historyItem.final_rate >= 2,
									green: 30 > historyItem.final_rate && historyItem.final_rate >= 6,
									gold: 300 > historyItem.final_rate && historyItem.final_rate >= 30,
									purple: historyItem.final_rate >= 300
								}"
							> x{{historyItem.final_rate}}</div>
						</div>
						<button type="button" class="crash__history-btn" @click="expandHistory = !expandHistory">
							<svg class="crash__history-btn-icon">
								<use href="#svg-icon-chevron"></use>
							</svg>
						</button>
					</div>
					<div class="crash__rocket" id="crashRocket">
						<img :src="imgDir + '/fire1.png'" id="crashFire1" alt="">
						<img :src="imgDir + '/fire2.png'" id="crashFire2" alt="">
						<img :src="imgDir + '/fire3.png'" id="crashFire3" alt="">
						<span id="crashGlare"></span>
						<img :src="imgDir + '/rocket.png'" id="crashShip" alt="">
						<img :src="imgDir + '/plasma.png'" id="crashPlasma" alt="">
					</div>
					<div class="crash__boom">
						<img class="crash__boom-img" :src="imgDir + '/b1.png'" alt="">
						<img class="crash__boom-img" :src="imgDir + '/b2.png'" alt="">
						<img class="crash__boom-img" :src="imgDir + '/b3.png'" alt="">
						<img class="crash__boom-img" :src="imgDir + '/b4.png'" alt="">
						<img class="crash__boom-img" :src="imgDir + '/b5.png'" alt="">
						<img class="crash__boom-img" :src="imgDir + '/b6.png'" alt="">
						<img class="crash__boom-img" :src="imgDir + '/b7.png'" alt="">
						<img class="crash__boom-img" :src="imgDir + '/b8.png'" alt="">
						<img class="crash__boom-img" :src="imgDir + '/b9.png'" alt="">
						<img class="crash__boom-img" :src="imgDir + '/b10.png'" alt="">
					</div>
					<transition name="crash-counter">
						<div v-if="game" class="crash__counter crash__counter--left">
							<div class="crash__counter-value">{{coef.toFixed(2)}}x</div>
							<div class="crash__counter-label">Высота</div>
						</div>
					</transition>
					<transition name="crash-counter">
						<div v-if="!game" class="crash__counter crash__counter--left">
							<div class="crash__counter-value"><Timer :time="countdown"/></div>
							<div class="crash__counter-label">Обратный отсчет</div>
						</div>
					</transition>
					<transition name="crash-counter">
						<div v-if="game" class="crash__counter crash__counter--right">
							<div v-if="pause" class="crash__counter-value">{{ formattedTime(this.time) }}</div>
							<div v-else class="crash__counter-value"><Timer :time="time" increment /></div>
							<div class="crash__counter-label">Время полета</div>
						</div>
					</transition>
				</div>

				<div class="crash__controls" :class="[game ? 'disabled' : '']" v-for="(bet, idx) in bets">
					<div class="crash__control game-controls">
						<button class="game-controls__item" @click="typeBet('min', bet)" type="button" :disabled="bet.id">Мин</button>
						<button class="game-controls__item" @click="typeBet('/2', bet)" type="button" :disabled="bet.id">÷2</button>
						<label class="game-controls__bet">
							<div class="game-controls__bet-value">
								<div class="game-controls__bet-value-wrap">
									<div class="game-controls__bet-value-plug">{{bet.amount}}</div>
									<input class="game-controls__bet-value-input"
										   type="number"
										   v-model="bet.amount"
										   @keyup="validateBet(bets[idx])"
										   autocomplete="off"
										   :disabled="bet.id"
									>
								</div>₽
							</div>
							<div class="game-controls__bet-label">Ставка</div>
						</label>
						<button class="game-controls__item" @click="typeBet('x2', bet)" type="button" :disabled="bet.id">×2</button>
						<button class="game-controls__item" @click="typeBet('max', bet)" type="button" :disabled="bet.id">Макс</button>
					</div>

					<div class="crash__control-btns">
						<div class="crash__auto">
							<div class="crash__auto-info">
								<div class="crash__auto-value">x
									<span class="crash__auto-input-wrap">
									<input class="crash__auto-value-input" type="number" v-model="bet.auto_rate" @blur="handlerAutoCoefBlur(bets[idx])" :disabled="bet.id">
								</span>
								</div>
								<div class="crash__auto-label">Автовывод</div>
							</div>
							<button type="button" class="crash__auto-switch" :class="{active: bet.auto_rate_on}" @click="bet.auto_rate_on = !bet.auto_rate_on" :disabled="bet.id"></button>
						</div>
						<template v-if="game">
							<template v-if="bet.id">
								<template v-if="pause || bet.win">
									<button v-if="bet.win" class="btn btn--success crash__control crash__control-btn">Победа <br>{{bet.win}} ₽</button>
									<button v-else class="btn btn--red crash__control crash__control-btn">Проигрыш</button>
								</template>
								<button v-else @click="getWin(bets[idx])" class="btn btn--success crash__control crash__control-btn">Забрать<br>{{(bet.amount * coef).toFixed(2)}} ₽</button>
							</template>
							<button v-else disabled class="btn crash__control crash__control-btn">Ожидание<br> след. раунда</button>
						</template>
						<template v-else>
							<button v-if="bet.id" @click="leaveGameSocket(bets[idx])" class="btn btn--red crash__control crash__control-btn">Отмена</button>
							<button v-else @click="joinGameSocket(bets[idx])" class="btn crash__control crash__control-btn">Играть</button>
						</template>
					</div>
				</div>
			</div>
			<div class="crash__players">
				<div class="crash__players-list no-scrollbar" v-if="players?.length" data-scroll-lock-scrollable>
					<Players :players="players"/>
				</div>
				<div v-else>Ставок нет</div>
			</div>
		</div>
	</div>
</template>

<script>

	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';
	import Players from "../../components/blocks/Players.vue";
	import Timer from "../../components/blocks/Timer.vue";

    export default {
		components: {
			Timer,
			Players
		},

        data() {
            return {
				bets: [
					{
						id: null,
						amount: 1,
						number: 1,
						auto_rate_on: false,
						auto_rate: 2.00,
						win: null
					},
					{
						id: null,
						amount: 1,
						number: 2,
						auto_rate_on: false,
						auto_rate: 2.00,
						win: null
					}
				],
				coef: 1,
				game: false,
				time: 0,
				countdown: 0,
				pause: false,
				disableBtn: false,
				ready: false,
				swiper: null,
				players: [],
				history: [],
				expandHistory: false
			}
        },

        mounted() {
            this.$root.isLoading = false;
			this.getGameStatus();
			this.getBets();
            this.getHistory();
        },

		computed: {
			...mapState(useUserStore, ['user']),

			imgDir() {
				return window.location.hostname === 'localhost' ? '/images' : '/assets/boomx/images';
			}
		},

		watch: {
			game(state) {
				if (state) {
					this.ready = false;
				}
			},

			countdown(state) {
				if (state && state <= 3000) {
					this.ready = true;
				}
			}
		},

        methods: {
			getGameStatus() {
				this.$root.axios.get('/api/game/crash/current')
					.then(res => {
						if (res.data.data?.status === 'ongoing') {
							this.game = true;
						}
					}).catch(e => {})
			},

            getBets() {
                this.$root.axios.get('/api/game/crash/bets')
                    .then(res => {
						let bets = res.data.data.bets
						this.players = bets;
						bets.forEach(resBet => {
							if (resBet.user.id === this.user.id && resBet.number) {
								let curBet = this.bets.find(bet => bet.number === resBet.number);
								curBet.id = resBet.id;
								curBet.amount = resBet.amount;
								if (resBet.auto_rate) {
									curBet.auto_rate_on = true;
									curBet.auto_rate = resBet.auto_rate;
								}
							}
						})
					}).catch(e => {})
            },

			getHistory() {
				this.$root.axios.get('/api/game/crash/history')
					.then(res => this.history = res.data.data).catch(e => {})
			},

			resetGame() {
				this.pause = false;
				this.game = false;
				this.ready = false;
				this.win = null;
				this.bets.forEach(bet => {
					bet.id = null;
					bet.win = false;
				})
				this.countdown = 0;
				this.time = 0;
				this.players = [];
				this.getHistory()
			},

			joinGameSocket(betInst) {
				// if (!this.user) {
				// 	this.$root.emitter.emit('openAuth', () => this.singIn = true);
				// return
				// }
				// if(!this.user.balance) {
				// 	return this.$toast.error('На вашем балансе недостаточно средств');
				// }
				this.$root.axios.post('/api/game/crash/bet/create', {
					amount: betInst.amount,
					number: betInst.number,
					auto_rate: betInst.auto_rate_on ? betInst.auto_rate : null
				}).then(res => {
					let resBet = res.data.data.bet;
					if (res.data.success) {
						let currentBet = this.bets.find(bet => bet.number === resBet.number);
						currentBet.id = resBet.id;
					}
					this.updateBalance(res);
				})
			},

			leaveGameSocket(betInst) {
				this.$root.axios.post('/api/game/crash/bet/cancel', {
					bet_id: betInst.id
				}).then(res => {
					if (res.data.success) {
						betInst.id = null;
					}
					this.updateBalance(res);
				})
			},

			getWin(betInst) {
				this.$root.axios.post('/api/game/crash/bet/take', {
					bet_id: betInst.id
				}).then(res => this.updateBalance(res))
			},

			updateBalance(res) {
				if (res?.data?.data) this.user.balance = res?.data?.data?.balance;
			},

            typeBet(type, betInst) {
                switch (type) {
                    case "max":
                        if (this.user !== null) {
							betInst.amount = this.user.balance;
                        } else {
							betInst.amount = 0;
                        }
                        break;
                    case "min":
						betInst.amount = this.user.balance < 1 ? this.user.balance : 1;
                        break;
                    case "x2":
						betInst.amount = (betInst.amount * 2).toFixed(2);
                        break;
                    case "/2":
						betInst.amount = (betInst.amount / 2).toFixed(2);
                        break;
                    case "-":
						betInst.auto_rate = (betInst.auto_rate - 0.10).toFixed(2);
                        break;
                    case "+":
						betInst.auto_rate = (betInst.auto_rate + 0.10).toFixed(2);
                        break;
                }
                this.validateBet(betInst);
            },
            validateBet(betInst) {
                if(Number(betInst.amount) && betInst.amount < 1) {
					betInst.amount = 1;
                }
            },

			handlerAutoCoefBlur(betInst) {
				if(!betInst.auto_rate) {
					betInst.auto_rate = 2;
				}
			},

			formattedTime(time) {
				let minutes = Math.floor(time / 60000);
				let seconds = ((time % 60000) / 1000).toFixed(0);
				let ms = (((time % 60000) % 1000) / 10).toFixed(0)
				return (minutes ? minutes + ":" : '') + (seconds < 10 ? '0' : '') + seconds + ":" + (ms < 10 ? '0' : '') + ms;
			},

			setWinner(win) {
				let currentBetIdx = this.players.findIndex(bet => bet.id === win.id);
				if (win.lose) {
					this.players[currentBetIdx].lose = win.lose;
				} else {
					this.players[currentBetIdx] = win;
					let localBetIdx = this.bets.findIndex(bet => bet.id === win.id);
					if (localBetIdx || localBetIdx === 0 ) {
						this.bets[localBetIdx].win = win.final_rate * win.amount;
					}
				}
			}
		},
        sockets: {
			'crash.game.cooldown': function(data) {
				this.countdown = data.cooldown
				// console.log('Cooldown', data); // Обратный отсчёт до начала
			},
			'crash.game.tick': function (data) {
				this.coef = data.current_rate;
				this.time = data.round_time;
				// console.log('Tick', data);  // Каждый тик игры
			},
			'crash.game.ongoing': function(data) {
				this.game = true
				this.pause = false;
				// console.log('Start', data); // Отображение кэфа во время полёта ракеты, кэфы и отсчёт идут практически реалтайм
			},
			'crash.game.finish': function(data) {
				this.pause = true;
				setTimeout(this.resetGame, 3000);
				// console.log('Finish', data); // Раунд закончился
			},
			'crash.bets.lose': function(data) {
				data.forEach(bet => this.setWinner({id: bet, lose: true}))
				console.log('Bets lose', data); // Список проигранных ставок после завершения раунда
			},
			'crash.bet.add': function(data) {
				this.players.push(data);
				console.log('Bet new', data); // Новая ставка в раунде
			},
			'crash.bet.cancel': function(data) {
				this.players = this.players.filter(bet => bet.id !== data.id);
				console.log('Bet cancel', data); // Отменили ставку
			},
			'crash.bet.win': function(data) {
				this.setWinner(data)
				console.log('Bet win', data); // Человек вручную забрал победную ставку
			},
			'crash.bets.win': function(data) {
				data.forEach(bet => this.setWinner(bet))
				console.log('Bets win', data); // Список выигранных ставок с auto rate
			}
        }
	}
</script>
